import { IClientOption, IUserOption } from 'components/SingleTask/taskAside'
import { GtmTaskmBlockEnum } from '../gtm/model'
import { IAutocompleteOption } from 'components/shared'
import { TColor } from '@centra/centra-ui'
import { IItemList } from '../model'

export enum ActionType {
  RESET_TASK_MANAGER = 'RESET_TASK_MANAGER',

  START_WATCH_TASKS = 'START_WATCH_TASKS',
  STOP_WATCH_TASKS = 'STOP_WATCH_TASKS',
  TICK_WATCH_TASKS = 'TICK_WATCH_TASKS',

  GET_URGENT_TASKS = 'GET_URGENT_TASKS',
  SET_URGENT_TASKS = 'SET_URGENT_TASKS',

  GET_ACCOUNT_MANAGERS_TASKS = 'GET_ACCOUNT_MANAGERS_TASKS',
  SET_ACCOUNT_MANAGERS_TASKS = 'SET_ACCOUNT_MANAGERS_TASKS',

  GET_CLIENTS_TASKS = 'GET_CLIENTS_TASKS',
  SET_CLIENTS_TASKS = 'SET_CLIENTS_TASKS',

  GET_CLIENT_MANAGERS_TASKS = 'GET_CLIENT_MANAGERS_TASKS',
  SET_CLIENT_MANAGERS_TASKS = 'SET_CLIENT_MANAGERS_TASKS',

  GET_DONE_TASKS = 'GET_DONE_TASKS',
  SET_DONE_TASKS = 'SET_DONE_TASKS',

  GET_MANAGERS_DONE_TASKS = 'GET_MANAGERS_DONE_TASKS',
  SET_MANAGERS_DONE_TASKS = 'SET_MANAGERS_DONE_TASKS',

  GET_ALL_TASKS = 'GET_ALL_TASKS',
  SET_ALL_TASKS = 'SET_ALL_TASKS',

  REMOVE_TASK_FILTER = 'REMOVE_TASK_FILTER',
  ADD_TASK_FILTER = 'ADD_TASK_FILTER',
  CLEAR_ALL_TASK_FILTERS = 'CLEAR_ALL_TASK_FILTERS',
  UPDATE_FILTERS_BY_QUERY = 'UPDATE_FILTERS_BY_QUERY',

  SET_COLLAPSED_TASK_GROUP = 'SET_COLLAPSED_TASK_GROUP',
  SET_FULL_LIST_TASK_GROUP = 'SET_FULL_LIST_TASK_GROUP',

  GET_TASK_LIST_BY_ACTIVE_TASK = 'GET_TASK_LIST_BY_ACTIVE_TASK',

  POST_TASK = 'POST_TASK',
  POST_TASK_CONNECT_PRODUCT = 'POST_TASK_CONNECT_PRODUCT',
  POST_TASK_CONNECT_PRODUCT_CABINET = 'POST_TASK_CONNECT_PRODUCT_CABINET',
  POST_TASK_PAYMENT_CABINET = 'POST_TASK_PAYMENT_CABINET',

  CHANGE_ACTIVE_TASK = 'CHANGE_ACTIVE_TASK',
  GET_TASK = 'GET_TASK',
  SET_TASK = 'SET_TASK',
  PATCH_TASK = 'PATCH_TASK',

  MOVE_TASK = 'MOVE_TASK',
  ARCHIVE_TASK = 'ARCHIVE_TASK',

  GET_TASK_MESSAGES = 'GET_TASK_MESSAGES',
  GET_TASK_MESSAGES_INTERVAL = 'GET_TASK_MESSAGES_INTERVAL',
  SET_TASK_MESSAGES = 'SET_TASK_MESSAGES',
  POST_TASK_MESSAGE = 'POST_TASK_MESSAGE',
  GET_TASK_FILE = 'GET_TASK_FILE',

  GET_CATEGORIES = 'GET_CATEGORIES',
  SET_CATEGORIES = 'SET_CATEGORIES',

  GET_STATUSES = 'GET_STATUSES',
  SET_STATUSES = 'SET_STATUSES',

  GET_ACCOUNT_CLIENTS = 'GET_ACCOUNT_CLIENTS',
  SET_ACCOUNT_CLIENTS = 'SET_ACCOUNT_CLIENTS',

  GET_TASK_CLIENT_PRODUCTS = 'GET_TASK_CLIENT_PRODUCTS',
  SET_TASK_CLIENT_PRODUCTS = 'SET_TASK_CLIENT_PRODUCTS',
}

export type ITaskType = 'urgent' | 'managers' | 'clients' | 'done'

export type ICategoryType = 'connection' | 'payment' | 'openCabinet' | 'support' | 'other'

export type IStatusType = 'briefing' | 'inProgress' | 'needInformation' | 'done' | 'reject' | 'research'

export type IPublishedType = 'briefing' | 'inProgress' | 'needInformation' | 'done' | 'reject'

export interface ITaskClient {
  id: number
  name: string
  kind: 'agency' | 'advertiser' | 'agencyClient'
  archivedAt: string | null
  agencyName: string | null
  agencyId: number | null
  agencyArchivedAt: string | null
}

export interface ITask {
  id: number
  name: string
  category: {
    id: number
    name: string
    colorAlias: TColor
    // type: ICategoryType
  }
  status: {
    id: number
    name: string
    colorAlias: TColor
    // type: IStatusType
  }
  topic: {
    id: number
    name: string
  }
  client: ITaskClient
  assigned: IUserOption
  clientManager: IUserOption
  participants?: IUserOption[]
  lastCommunicationUser?: IUserOption | null
  finCoordinators?: IUserOption[]
  propertyValues?: IPropertyValue[]
  createdBy?: IUserOption
  createdFrom: 'marketplace' | 'task-manager'
  createdAt?: string
  active?: boolean
  attachedFile?: boolean
  adminView?: boolean
  urgent?: boolean
  managers?: boolean
  taskType?: ITaskType
  unreadMessageCount?: number
  taskUpdateCount?: number
  product?: string
  productType?: string
  author?: IUserOption
  isClientConfirm?: boolean
  clientManagerTags?: string[]
  assignedAccountTags?: string[]
}

export interface IMoveTask {
  taskType: ITaskType
  task: ITask
}

export interface IPostTask {
  id?: number
  name: string
  category: {
    id: number
    name: string
    colorAlias: TColor
  } | null
  status: {
    id: number
    name: string
    colorAlias: TColor
  } | null
  client: IClientOption | null
  clientManager?: IUserOption | null
  accountManager?: IUserOption | null
  assigned?: IUserOption | null
  participants?: IUserOption[]
  lastCommunicationUser?: IUserOption | null
  finCoordinators?: IUserOption[]
  propertyValues?: IPropertyValue[]
  productId?: number
  author?: IUserOption
  isClientConfirm?: boolean
}

export interface IClientPatchTask {
  id?: number
  assigned?: IUserOption | null
}

export interface IGetTaskClientProducts {
  clientId?: number
}

export interface IPostClientTaskSagaNew {
  templateGid?: string
  clientId?: number
  clientName?: string
  productId?: number
  productName?: string
  cabinetId?: number
  cabinetName?: string
  amount?: number
  debugInfo?: any
}

export interface IPostClientTaskForm {
  category?: IAutocompleteOption
  product?: IAutocompleteOption
  client?: IAutocompleteOption
  amount?: string | number
  cabinetId?: IAutocompleteOption | number
  propertyValues?: IPropertyValueBase[]
  templateGid?: string
}

export interface IPostClientTask extends IPostClientTaskForm {
  location: 'taskm' | 'advertiser_account'
}

export interface IPostClientTaskConnectProduct {
  clientId?: number
  clientName?: string
  productId?: number
  productName?: string
  productTypeName?: string
}

export const MESSAGE_PAGE_SIZE = 20

// аттачи - это тоже сообщения, но с другим контентом в params
export type TMessageKind = 'add_message' | 'edit_status' | 'edit_name' | 'edit_assigned' | 'edit_category'

export interface IMessage {
  kind: TMessageKind
  params: any

  id: number
  taskId: number
  sender: {
    id: number
    firstName: string
    lastName: string
    avatar: string
    roles: string[]
  }
  createdAt: string
}

export interface ITaskMassages {
  data: IMessage[]
  totalCount: number
  newMessages: number
}

export const TABS = {
  ACTIVE_TAB: 'active',
  DONE_TAB: 'done',
}

type TabTypes = keyof typeof TABS

export type TaskManagerTabType = typeof TABS[TabTypes]

export interface ITaskGroupState {
  collapsed: boolean
  isFullList: boolean
}

export interface ITaskGroupStateStore {
  urgent: ITaskGroupState
  managers: ITaskGroupState
  clientManagers: ITaskGroupState
  clients: ITaskGroupState
  done: ITaskGroupState
  managersDone: ITaskGroupState
}

export interface ITasksStore {
  urgent: IItemList<ITask>
  managers: IItemList<ITask>
  clientManagers: IItemList<ITask>
  clients: IItemList<ITask>
  done: IItemList<ITask>
  managersDone: IItemList<ITask>
}

export interface ISetTaskFilter {
  // В фильтре тасок теперь используем clientIds вместо agencyIds и advertiserIds
  type:
    | 'accountManagerIds'
    | 'advertiserIds'
    | 'agencyIds'
    | 'statusIds'
    | 'categoryIds'
    | 'clientIds'
    | 'supportTypeIds'
    | 'productIds'
  id: number
}

export interface IUpdateFiltersByQuery {
  accountManagerIds?: number[]
  advertiserIds?: number[]
  agencyIds?: number[]
  // В фильтре тасок теперь используем clientIds вместо agencyIds и advertiserIds
  clientIds?: number[]
  statusIds?: number[]
  categoryIds?: number[]
  supportTypeIds?: number[]
  docsTypeId?: number[]
  productIds?: number[]
  createdFrom?: string[]
  createdTo?: string[]
  taskId?: string[]
}

export interface ISetTaskGroupState {
  groupType: keyof typeof GtmTaskmBlockEnum
  state: boolean
}

export const TASK_REPORT_NG_API_URL = '/ng/v1/task/get'
export const TASK_NG_API_URL = '/ng/v1/task/get'
export const TASK_CATEGORY_NG_API_URL = '/ng/v1/taskCategory/get'
export const TASK_STATUS_NG_API_URL = '/ng/v1/taskStatus/get'
export const TASK_MUTATE_NG_API_URL = '/ng/v1/task/mutate'

export const TASK_REPORT_NG_API_SELECTOR = {
  fields: [
    'id',
    'name',
    'isUrgent',
    'assignedAccountId',
    'assignedAccountRoles',
    'assignedAccountFirstName',
    'assignedAccountLastName',
    'assignedAccountAvatar',
    'assignedAccountTitle',
    'categoryId',
    'categoryName',
    'categoryColor',
    'statusId',
    'statusName',
    'statusColor',
    'topicId',
    'topicName',
    'clientId',
    'clientName',
    'clientKind',
    'clientAgencyId',
    'clientAgencyName',
    'clientAgencyArchivedAt',
    'oldAgencyId',
    'counterUnreadMessage',
    'counterTaskUpdate',
    'clientManagerId',
    'clientManagerRoles',
    'clientManagerFirstName',
    'clientManagerLastName',
    'clientManagerAvatar',
    'clientManagerTitle',
    'createdAt',
    'clientManagers',
    'clientArchivedAt',
    'isClientConfirm',
    'clientManagerTags',
    'assignedAccountTags',
  ],
  predicates: [
    {
      field: 'isArchived',
      operator: 'EQUALS',
      values: [false],
    },
  ],
  ordering: [
    {
      field: 'summaryUpdatedAt',
      sortOrder: 'DESC',
    },
  ],
}

export const TASK_NG_API_SELECTOR = {
  fields: [
    'id',
    'name',
    'isUrgent',
    'assignedTo',
    'categoryId',
    'statusId',
    'topicId',
    'clientId',
    'clientManagerId',
    'bulkEnrollmentRequestId',
  ],
  predicates: [
    {
      field: 'isArchived',
      operator: 'EQUALS',
      values: [false],
    },
  ],
  ordering: [
    {
      field: 'updatedAt',
      sortOrder: 'DESC',
    },
  ],
}

export enum StatusTypeIds {
  'briefing' = 1,
  'inProgress' = 2,
  'needInformation' = 3,
  'done' = 4,
  'reject' = 5,
  'research' = 6,
  'onConfirmed' = 7,
}

export enum CategoryTypeIds {
  'connection' = 1,
  'payment' = 2,
  'openCabinet' = 3,
  'other' = 4,
  'support' = 5,
  'docs' = 7,
  'ai' = 11,
}

export interface IPropertyOptionValue {
  id: number
  name: string
}

export interface IPropertyValueBase {
  id: number
  propertyId: number
  name: string
  value: string | number | boolean | IPropertyOptionValue[]
}
export interface IPropertyValue extends IPropertyValueBase {
  name: string
  propertyId: number
  propertyGid?: string
}

export enum DashboardColumns {
  MY_URGENT_TASKS = 'urgent',
  MY_TASKS = 'managers',
  CLIENT_TASKS = 'clients',
  FINISHED_TASKS = 'done',
}

export enum TaskStatus {
  BRIEFING = 1,
  IN_PROGRESS = 2,
  REQUIRES_CLARIFICATION = 3,
  DONE = 4,
  REJECTED = 5,
  REVIEW = 6,
}

export const IS_OPEN_SURVEY_FORM_KEY = '_is_open_survey_form'

export const FETCH_ACCOUNT_SURVEY_COUNTER_TIMEOUT = 8000

export type AccountSurveyCounterCategoryAssociation = {
  // ID категории
  categoryId: number
  // Текущее значение счетчика из хранилища
  count: number
  // Значение счетчика, при котором нужно показать попап
  chargeCount: number
}

/**
 * Значения счетчиков, при достижении которых будет показываться попап с предложением пройти опрос по задаче
 */
export const AccountSurveyCounterChargeCount = {
  connection: 1,
  payment: 4,
  openCabinet: 4,
  support: 2,
  other: 2,
} as const

export type TaskSurveyFormData = {
  taskId: number
  taskCategoryId: number
  accountManagerId: number
  isSurveySuccess: boolean
  speedRating: number
  qualityRating: number
  message: string
}

export type PostTaskSurveyAnswer = Omit<TaskSurveyFormData, 'taskCategoryId'> &
  (
    | {
        isPopupClosed: boolean
        breakpoint: 'DESKTOP' | 'TABLET' | 'MOBILE'
      }
    | {
        isFormOpened: boolean
        breakpoint: 'DESKTOP' | 'TABLET' | 'MOBILE'
      }
  )
